// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.

import { version } from "prettier";

// The list of file replacements can be found in `angular.json`
export const environment = {
    production: true,
    version:'1.0.0',
    api_url: 'https://api.platform.eg-1.nymcard.com/',
    agentRoleId: '',
    googleMapApiKey: 'REPLACE_WITH_SECRET',
    tenantKeyPassphrase: 'REPLACE_WITH_TENANT_KEY',
};

export const tenantSetting = [
    { key: 'tenant1', name: 'tenant1' }
];

export const customerTenant = {
    FIB: '',
    SAMSUNG: 'SAMSUNG',
    INC: 'INC',
    NASS: 'NASS',
    BAYBLOS: 'BAYBLOS',
    EDB: 'EDB',
    EG: 'EG',
    IC: 'IC',
    ATA: 'ATA',
    VEEZETA:'tenant1_api'
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
